export default {"src":"/_next/static/image/public/images/flags/flag_672.3a35ef6d615458b1c77fa67ce05b9795.svg","height":16,"width":25};